
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
// components
// interfaces
import { namespace } from "vuex-class";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";

const globals = namespace("globals");

@Component({
  components: {
  },
})
export default class TextElement extends Vue {
  @Prop() element!: CourseElementVm;

  @globals.Getter selectedExercise!: ExerciseVM;

  isBusy = false;
  showHtmlEditor = false;

  mounted() {}


  openHtmlditor() {
    this.showHtmlEditor = true;
  }

  // get compSettings() {
  //   return `{ enableZoom: ${this.element.enableZoom} }`;
  // }
}
